import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScrollComponent from "../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import Modal from "../../../../components/Common/Modal/Modal";
import ForwardLinkIcon from "../../../../components/Common/SvgIcons/SocialIcons/ForwardLinkIcon";
import ToggleButton from "../../../../components/Common/ToggleButton/ToggleButton";
import {
  setCreateForumThreadResponse,
  setForumThreads,
  setForumTopics,
} from "../../../../store/actions/actionCreators/socialActionCreator";
import {
  getForumThreadsActionHandler,
  updateForumThreadActionHandler,
  updateForumTopicActionHandler,
} from "../../../../store/actions/actionHandlers/socialActionHandler";
import actionTypes from "../../../../store/actions/actionTypes";
import CreateForumThread from "./CreateForumThread/CreateForumThread";
import classes from "./ForumThreads.module.scss";
import Loader from "../../../../components/Common/Loader/Loader";
import { FormattedMessage } from "react-intl";

const ForumThreads = ({
  selectedForumTopicData,
  setselectedForumTopicData,
  forwardLinkIconClick,
}) => {
  const pageSize = 10;
  const dispatch = useDispatch();
  const socialState = useSelector((state) => state.socialReducer);
  const { createForumThreadResponseData, forumTopics, forumThreads } =
    socialState;
  const [pageNum, setpageNum] = useState(1);
  const [forumThreadsData, setForumThreadsData] = useState(null);
  const [createForumThreadModal, setCreateForumThreadModal] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [totalRows, settotalRows] = useState(0);
  const [isBoolean, setIsBoolean] = useState(false);
  const [threadLoader, setThreadLoader] = useState(false);

  useEffect(() => {
    forumTopics?.forEach((data) => {
      if (data?.Id === selectedForumTopicData?.Id) {
        setIsBoolean(false);
        setselectedForumTopicData(data);
      }
    });
    // dispatch({
    //   type: actionTypes.socialTypes.FORUM_AREA.FORUM_THREADS,
    //   payload: null,
    // });
  }, [
    forumTopics,
    setselectedForumTopicData,
    selectedForumTopicData,
    dispatch,
  ]);

  const handleTopicToggleClick = (isEnable) => {
    setIsBoolean(true);
    if (selectedForumTopicData) {
      const updatedData = forumTopics?.map((data) => {
        if (data?.Id === selectedForumTopicData?.Id)
          return { ...data, IsEnabled: isEnable ? false : true };
        else return data;
      });
      dispatch(setForumTopics(updatedData));
      const obj = {
        Id: selectedForumTopicData?.Id,
        IsEnabled: isEnable ? false : true,
      };
      dispatch(updateForumTopicActionHandler(obj));
    }
  };

  useEffect(() => {
    if (createForumThreadResponseData) {
      dispatch(
        getForumThreadsActionHandler(
          selectedForumTopicData?.Id,
          1,
          pageSize,
          setForumThreadsData,
          settotalRows,
          setThreadLoader
        )
      );
    }
    if (selectedForumTopicData && !isBoolean) {
      setpageNum(1);
      setHasMoreData(true);
      dispatch(
        getForumThreadsActionHandler(
          selectedForumTopicData?.Id,
          1,
          pageSize,
          setForumThreadsData,
          settotalRows,
          setThreadLoader
        )
      );
    }
  }, [
    createForumThreadResponseData,
    dispatch,
    selectedForumTopicData,
    isBoolean,
  ]);

  useEffect(() => {
    if (selectedForumTopicData && !isBoolean) {
      if (pageNum > 1)
        dispatch(
          getForumThreadsActionHandler(
            selectedForumTopicData?.Id,
            pageNum,
            pageSize,
            setForumThreadsData,
            settotalRows,
            setThreadLoader
          )
        );
    }
  }, [pageNum, dispatch, isBoolean, selectedForumTopicData]);

  const fetchMoreData = () => {
    if (forumThreadsData?.length >= totalRows) {
      setHasMoreData(false);
      return;
    }
    setpageNum(pageNum + 1);
  };

  const handleThreadToggleClick = (isEnable, id) => {
    const obj = {
      Id: id,
      IsEnabled: isEnable ? false : true,
    };
    dispatch(updateForumThreadActionHandler(obj));
    const updatedData = forumThreads?.map((data) => {
      if (data?.Id === id)
        return { ...data, IsEnabled: isEnable ? false : true };
      else return data;
    });
    dispatch(setForumThreads(updatedData));
  };
  return (
    <div className={classes.forumTopicThread}>
      <div className={classes.forumTopicThreadHeading}>
        <ToggleButton
          enable={selectedForumTopicData?.IsEnabled}
          handleClick={() =>
            handleTopicToggleClick(selectedForumTopicData?.IsEnabled)
          }
        />
        <span className={classes.topicDetails}>
          {selectedForumTopicData?.ForumThreadCount}{" "}
          <FormattedMessage id="FORUM_THREAD" />
        </span>
        <span
          className={classes.topicDetails}
          title={selectedForumTopicData?.CreatedBy}
        >
          <FormattedMessage id="FORUM_CREATED_BY" /> :&nbsp;
          {selectedForumTopicData?.CreatedBy?.length > 11
            ? selectedForumTopicData?.CreatedBy?.slice(0, 11) + "..."
            : selectedForumTopicData?.CreatedBy}
        </span>
        <span className={classes.topicDetails}>
          {selectedForumTopicData?.CreatedOn.slice(
            0,
            selectedForumTopicData?.CreatedOn.indexOf(" ")
          )}{" "}
          {selectedForumTopicData?.CreatedOn.slice(
            selectedForumTopicData?.CreatedOn.indexOf(" ") + 1,
            selectedForumTopicData?.CreatedOn.length
          )}
        </span>
        {forumTopics?.length >= 1 && (
          <span
            className={classes.addNewThreadText}
            onClick={() => {
              setCreateForumThreadModal(true);
              dispatch(setCreateForumThreadResponse(null));
            }}
          >
            <FormattedMessage id="FORUM_NEW_THREAD" />
          </span>
        )}
      </div>
      {forumThreads?.length > 0 && (
        <InfiniteScrollComponent
          dataLength={forumThreads?.length ? forumThreads.length : 10}
          fetchMoreData={fetchMoreData}
          hasMoreData={hasMoreData}
          height={"100vh"}
        >
          {forumThreads?.map((thread, index) => {
            return (
              <div className={classes.threadContent} key={index}>
                <div className={classes.threadTttle}>
                  <span
                    onClick={() => forwardLinkIconClick(thread)}
                    className={classes.text}
                    // title={thread?.ThreadName}
                  >
                    {/* {thread?.ThreadName?.length > 130
                    ? thread?.ThreadName?.slice(0, 130) + "..."
                    : thread?.ThreadName} */}
                    {thread?.ThreadName}
                  </span>
                  <span
                    className={classes.forwardLinkIcon}
                    onClick={() => forwardLinkIconClick(thread)}
                  >
                    <ForwardLinkIcon />
                  </span>
                </div>
                <div className={classes.threadDetails}>
                  <div className={classes.threadcreatedBy}>
                    {thread?.CreatedBy} &nbsp;| &nbsp;{thread?.CreatedOn}
                  </div>
                  <div className={classes.comments}>
                    <ToggleButton
                      enable={thread?.IsEnabled}
                      handleClick={() =>
                        handleThreadToggleClick(thread?.IsEnabled, thread?.Id)
                      }
                    />
                    <span className={classes.topicDetails}>
                      <b>{thread?.ForumCommentsCount}</b>{" "}
                      <FormattedMessage id="FORUM_COMMENTS_TEXT" />
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </InfiniteScrollComponent>
      )}

      <div className={classes.noThreadsFound}>
        {!selectedForumTopicData
          ? "Please Select a Topic"
          : forumThreads?.length === 0 || !forumThreads
          ? "No Thread Found"
          : ""}
      </div>

      {/* {threadLoader && (
        <div className={classes.loader}>
          <Loader height="5%" width="5%" />
        </div>
      )} */}
      <Modal
        isOpen={createForumThreadModal}
        heading={<FormattedMessage id="FORUM_NEW_THREAD" />}
        toggle={() => {
          setCreateForumThreadModal(false);
        }}
        width={"45"}
      >
        <CreateForumThread
          topicsId={selectedForumTopicData?.Id}
          setCreateForumThreadModal={setCreateForumThreadModal}
        />
      </Modal>
    </div>
  );
};

export default ForumThreads;
